/* Provador compacto da FutNation (NODE, 2026-10-12): altura + peso + preferência de caimento → tamanho.
   O cálculo é do motor (size-provador.js → window.SizeProvadorMotor): tabela da loja + "size up" da
   loja. Tight/Loose andam um tamanho a partir do recomendado. Abre pelos acessos da PDP
   ([data-provador-open]; com [data-abrir-tabela] abre direto na vista de tabela). */
(function () {
  'use strict';
  var CHAVE = 'paceProvador'; // último altura/peso digitados, só pra preencher de novo
  function lerPerfil() { try { return JSON.parse(localStorage.getItem(CHAVE)) || {}; } catch (e) { return {}; } }
  function gravarPerfil(p) { try { localStorage.setItem(CHAVE, JSON.stringify(p)); } catch (e) { /* modo privado */ } }

  function montar(ov) {
    if (ov.pc) return ov.pc;
    var M = window.SizeProvadorMotor;
    var id = ov.id.replace('pc-overlay-', '');
    var dadosEl = document.querySelector('[data-pc-dados="' + id + '"]');
    if (!M || !dadosEl) return null;
    var dados = JSON.parse(dadosEl.textContent);
    var tabelas = dados.tables.map(function (t) { var p = M.parseTable(t); p.subtitulo = t.subtitulo || ''; return p; });
    var tabela = tabelas.filter(function (t) { return t.id === dados.detected; })[0] || tabelas[0];
    var infantil = tabela.kind === 'kids';
    var $ = function (sel) { return ov.querySelector(sel); };
    var estado = { fit: 'regular', r: null, valor: null, gatilho: null };

    function vista(nome) {
      [].forEach.call(ov.querySelectorAll('[data-pc-vista]'), function (v) { v.hidden = v.getAttribute('data-pc-vista') !== nome; });
      $('[data-pc-titulo]').textContent = nome === 'tabela' ? (dados.chartHeading || 'Size Chart') : (dados.heading || 'Size Finder');
      $('[data-pc-sub]').textContent = nome === 'tabela' ? tabela.title : tabela.subtitulo;
      $('[data-pc-sub]').hidden = !$('[data-pc-sub]').textContent;
      $('.pc-corpo').scrollTop = 0;
      // foco no modal, não no campo: no celular o campo focado abre o teclado por cima do modal
      setTimeout(function () { $('.pc-modal').focus({ preventScroll: true }); }, 50);
    }

    function abrir(nomeVista, gatilho) {
      estado.gatilho = gatilho || null;
      // valores iniciais como na referência (170 cm / 75 kg; infantil 120 / 22); o último digitado tem preferência
      var p = lerPerfil();
      if (!$('[data-pc-altura]').value) $('[data-pc-altura]').value = p.altura || (infantil ? 120 : 170);
      if (!$('[data-pc-peso]').value) $('[data-pc-peso]').value = p.peso || (infantil ? 22 : 75);
      ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      vista(nomeVista);
      requestAnimationFrame(function () { ov.classList.add('is-open'); });
    }

    function fechar() {
      ov.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { ov.hidden = true; }, 200);
      if (estado.gatilho && estado.gatilho.isConnected) estado.gatilho.focus({ preventScroll: true });
    }

    function erro(msg) { var e = $('[data-pc-erro]'); e.textContent = msg || ''; e.hidden = !msg; }

    // valores da opção de tamanho na página (rádios das pílulas do tema)
    function radios() {
      return [].slice.call(document.querySelectorAll('variant-selects fieldset.product-form__input--pill input[type="radio"], .product-form__input--size input[type="radio"]'));
    }

    function calcular() {
      var altura = parseFloat($('[data-pc-altura]').value);
      var peso = parseFloat($('[data-pc-peso]').value);
      var lim = infantil ? { a: [80, 185], p: [10, 90] } : { a: [100, 230], p: [30, 200] };
      if (!(altura >= lim.a[0] && altura <= lim.a[1])) return erro('Please enter a height between ' + lim.a[0] + ' and ' + lim.a[1] + ' cm.');
      if (!(peso >= lim.p[0] && peso <= lim.p[1])) return erro('Please enter a weight between ' + lim.p[0] + ' and ' + lim.p[1] + ' kg.');
      erro('');
      var perfil = { sexo: /feminin|women|woman|ladies/i.test(tabela.title || '') ? 'F' : 'M', altura: altura, peso: peso, idade: infantil ? null : 30 };
      if (!infantil) { var corpo = M.estimateBody(perfil); perfil.peito = corpo.peito; perfil.cintura = corpo.cintura; perfil.quadril = corpo.quadril; }
      estado.r = M.recommend(tabela, perfil);
      gravarPerfil({ altura: altura, peso: peso });
      mostrar();
    }

    function mostrar() {
      var r = estado.r; if (!r) return;
      var n = tabela.sizes.length;
      var passo = estado.fit === 'tight' ? -1 : estado.fit === 'loose' ? 1 : 0;
      var valores = radios().map(function (x) { return x.value; });
      var casa = function (k) { return valores.length ? M.casarVariante(tabela, tabela.sizes[k], valores) : null; };
      var i = r.index;
      if (passo) {
        // anda até a próxima variante DIFERENTE: na infantil, "05-06" e "06-07" caem os dois em "6 Years"
        var base = casa(r.index), j = r.index + passo;
        while (j >= 0 && j < n && base !== null && casa(j) === base) j += passo;
        i = Math.max(0, Math.min(n - 1, j));
      }
      var tamanho = tabela.sizes[i];
      estado.valor = casa(i);
      $('[data-pc-tamanho]').textContent = estado.valor || tamanho;
      var nota = '';
      if (estado.fit === 'regular' && r.ajuste) nota = 'Includes our fit advice: this style runs small, so we went up ' + r.ajuste + (r.ajuste > 1 ? ' sizes.' : ' size.');
      else if (i === n - 1 && (r.aviso === 'MAX' || passo > 0 && r.index + passo > n - 1)) nota = 'This is our largest size for this style.';
      else if (i === 0 && (r.aviso === 'MIN' || passo < 0 && r.index + passo < 0)) nota = 'This is our smallest size for this style.';
      $('[data-pc-nota]').textContent = nota;
      $('[data-pc-nota]').hidden = !nota;
      $('[data-pc-resultado]').hidden = false;
      var res = $('[data-pc-resultado]');
      if (res.scrollIntoView) res.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function selecionar() {
      var alvo = estado.valor && radios().filter(function (x) { return x.value === estado.valor; })[0];
      if (!alvo) return erro('We could not select it for you. Please choose size ' + $('[data-pc-tamanho]').textContent + ' on the page.');
      alvo.click();
      fechar();
    }

    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('[data-pc-fechar]')) return fechar();
      var fit = e.target.closest('[data-pc-fit]');
      if (fit) {
        estado.fit = fit.getAttribute('data-pc-fit');
        [].forEach.call(ov.querySelectorAll('[data-pc-fit]'), function (b) {
          var on = b === fit; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        return mostrar();
      }
      if (e.target.closest('[data-pc-calcular]')) return calcular();
      if (e.target.closest('[data-pc-selecionar]')) return selecionar();
      var ir = e.target.closest('[data-pc-ir]');
      if (ir) return vista(ir.getAttribute('data-pc-ir'));
    });
    ov.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('.pc-input')) { e.preventDefault(); calcular(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) fechar(); });

    ov.pc = { abrir: abrir, fechar: fechar };
    return ov.pc;
  }

  document.addEventListener('click', function (e) {
    var gatilho = e.target.closest('[data-provador-open]');
    if (!gatilho) return;
    var ov = document.querySelector('[data-pc-overlay]');
    var pc = ov && montar(ov);
    if (!pc) return;
    e.preventDefault();
    pc.abrir(gatilho.hasAttribute('data-abrir-tabela') ? 'tabela' : 'finder', gatilho);
  });
})();
